<div id="sidebar" class="active">
  <div class="sidebar-wrapper active ps ps--active-y">
    <div class="sidebar-header">
      <div class="d-flex justify-content-between">
        <div class="logo">
          <a href="index.html"><img src="https://zuramai.github.io/mazer/demo/assets/images/logo/logo.png" alt="Logo" srcset="" /></a>
        </div>
        <div class="toggler">
          <a href="#" class="sidebar-hide d-xl-none d-block"><i class="bi bi-x bi-middle"></i></a>
        </div>
      </div>
    </div>
    <div class="sidebar-menu">
      <ul class="menu">
        <li class="sidebar-title">Menu</li>

        <li class="sidebar-item active">
          <a href="#" class="sidebar-link">
            <i class="fas fa-tachometer-alt"></i>
            <span>BALLINA</span>
          </a>
        </li>

        <li class="sidebar-item">
          <a href="#" class="sidebar-link">
            <i class="fas fa-box"></i>
            <span>SERVISIME</span>
          </a>
        </li>

        <li class="sidebar-item">
          <a href="#" class="sidebar-link">
            <i class="fas fa-box"></i>
            <span>SHITJE</span>
          </a>
        </li>

        <li class="sidebar-item">
          <a href="#" class="sidebar-link">
            <i class="fas fa-box"></i>
            <span>SHPENZIME</span>
          </a>
        </li>

        <li class="sidebar-item">
          <a href="#" class="sidebar-link">
            <i class="fas fa-box"></i>
            <span>PAISJE</span>
          </a>
        </li>

         <li class="sidebar-item">
          <a href="#" class="sidebar-link">
            <i class="fas fa-box"></i>
            <span>GARANCIONE</span>
          </a>
        </li>

        <li class="sidebar-item">
          <a href="#" class="sidebar-link">
            <i class="fas fa-box"></i>
            <span>BLERJE</span>
          </a>
        </li>

        <li class="sidebar-item">
          <a href="#" class="sidebar-link">
            <i class="fas fa-box"></i>
            <span>PUNTORET</span>
          </a>
        </li>

        <li class="sidebar-item">
          <a href="#" class="sidebar-link">
            <i class="fas fa-box"></i>
            <span>KLIENTET</span>
          </a>
        </li>

        <li class="sidebar-item">
          <a href="#" class="sidebar-link">
            <i class="fas fa-box"></i>
            <span>KONFIGURIME</span>
          </a>
        </li>

      </ul>
    </div>
    <button class="sidebar-toggler btn x"><i data-feather="x"></i></button>
    <div class="ps__rail-x" style="left: 0px; bottom: 0px">
      <div class="ps__thumb-x" tabindex="0" style="left: 0px; width: 0px"></div>
    </div>
    <div class="ps__rail-y" style="top: 0px; height: 969px; right: 0px">
      <div class="ps__thumb-y" tabindex="0" style="top: 0px; height: 568px"></div>
    </div>
  </div>
</div>
